import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultMemberPaymentCardWalletCardTypes = [
    {
        id: 'MasterCard',
        label: 'Mastercard',
        iconName: 'mastercard-logo'
    },
    {
        id: 'Maestro',
        label: 'Maestro',
        iconName: 'maestro-logo'
    },
    {
        id: 'American Express',
        label: 'American Express',
        iconName: 'amex-logo'
    },
    {
        id: 'Visa',
        label: 'Visa',
        iconName: 'visa-logo'
    }
];
export const memberPaymentCardWalletCardTypeValidator = Validator.object({
    id: nonEmptyStringValidator,
    label: nonEmptyStringValidator,
    iconName: nonEmptyStringValidator
});
